import { useCallback } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as server from '../server';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';

export const useFetchGoldenChips = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const translate = useComponentTranslations();

    return useCallback(() => {
        if (!isMounted()) {
            return;
        }

        dispatch(actions.toggleLoading(true));
        dispatch(actions.setError({ error: '' }));

        (async () => {
            try {
                const { data } = await server.getBalanceBreakdown();
                const goldenChipsBalances = data?.balances.filter(balance => balance.goldenChipsCount > 0);

                isMounted() && dispatch(actions.setGoldenChips(goldenChipsBalances));
            } catch (error) {
                isMounted() && dispatch(actions.setError({ error: translate('error') }));
            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();

    }, [isMounted, dispatch, translate]);
};
